import { render } from "./user-education.vue?vue&type=template&id=48ad748a&ts=true"
import script from "./user-education.vue?vue&type=script&lang=ts"
export * from "./user-education.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__